import { render } from "./PropChart.vue?vue&type=template&id=1b8c6d85"
import script from "./PropChart.vue?vue&type=script&lang=js"
export * from "./PropChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__